import React, { useCallback, isValidElement, cloneElement, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { isArrayLike } from 'mobx';
import isPromise from 'is-promise';
import classNames from 'classnames';
import isString from 'lodash/isString';
import isObject from 'lodash/isObject';
import Button from '../button';
import { FuncType } from '../button/enum';
import Dropdown from '../dropdown';
import Menu from '../menu';
import { $l } from '../locale-context';
import useComputed from '../use-computed';
import { TableCommandType } from '../table/interface';
import { ViewMode } from './enum';
const CardCommand = function CardCommand(props) {
    const { record, prefixCls, command, renderCommand = ({ command }) => command, dataSet, viewMode, commandsLimit = 1, } = props;
    const [item, setItem] = useState(null);
    const cardCommand = useComputed(() => {
        if (typeof command === 'function') {
            const colC = command({ dataSet, record });
            return renderCommand({ command: colC, viewMode, dataSet, record });
        }
        return renderCommand({ command, viewMode, dataSet, record });
    }, [record, command, dataSet, renderCommand]);
    const handleCommandDelete = useCallback((e) => {
        e.stopPropagation();
        dataSet.delete(record);
    }, [dataSet, record]);
    const renderCommands = useCallback(async () => {
        const classString = classNames(`${prefixCls}-command`);
        if (cardCommand) {
            const commands = [];
            const result = isPromise(cardCommand) ? await cardCommand : cardCommand;
            result.forEach(button => {
                let tableButtonProps = {};
                if (isArrayLike(button)) {
                    tableButtonProps = button[1] || {};
                    button = button[0];
                }
                if (isString(button) && button in TableCommandType) {
                    const getButtonProps = (type) => {
                        switch (type) {
                            case TableCommandType.delete:
                                return {
                                    funcType: FuncType.link,
                                    onClick: handleCommandDelete,
                                    // disabled,
                                    children: $l('Table', 'delete_button'),
                                };
                            default:
                        }
                    };
                    const defaultButtonProps = getButtonProps(button);
                    if (defaultButtonProps) {
                        const { afterClick, ...buttonProps } = tableButtonProps;
                        if (afterClick) {
                            const { onClick } = defaultButtonProps;
                            defaultButtonProps.onClick = async (e) => {
                                e.persist();
                                e.stopPropagation();
                                try {
                                    await onClick(e);
                                }
                                finally {
                                    afterClick(e);
                                }
                            };
                        }
                        const { ...otherProps } = defaultButtonProps;
                        commands.push(React.createElement(Button, Object.assign({}, otherProps, buttonProps, { className: classNames(classString, otherProps.className, buttonProps.className) })));
                    }
                }
                else if (isValidElement(button)) {
                    commands.push(cloneElement(button, {
                        ...button.props,
                        onClick: (e) => {
                            e.stopPropagation();
                            button.props.onClick(e);
                        },
                        funcType: FuncType.link,
                        className: classNames(classString, button.props.className),
                    }));
                }
                else if (isObject(button)) {
                    commands.push(React.createElement(Button, Object.assign({}, button, { funcType: FuncType.link, className: classNames(classString, button.className) })));
                }
            });
            return commands;
        }
    }, [prefixCls, record, cardCommand, handleCommandDelete]);
    useEffect(() => {
        const renderMenuItem = async () => {
            const result = await renderCommands();
            setItem(result); // 更新状态
        };
        renderMenuItem();
    }, []);
    const renderMoreBtns = useCallback(() => {
        if (commandsLimit >= item.length) {
            return null;
        }
        return (React.createElement(Dropdown, { popupClassName: `${prefixCls}-quote-container-extra-popup`, overlay: () => (React.createElement(Menu, null, item.slice(commandsLimit).map(cmd => (React.createElement(Menu.Item, { key: cmd.key || `${record.id}_cmd` }, cmd))))) },
            React.createElement(Button, { icon: "more_horiz", funcType: FuncType.flat, onClick: (e) => e.stopPropagation() })));
    }, [item, commandsLimit]);
    return (item ? (viewMode === ViewMode.kanban ? React.createElement("div", { className: `${prefixCls}-quote-container-extra` },
        item.slice(0, commandsLimit),
        renderMoreBtns()) : (React.createElement(React.Fragment, null,
        item.slice(0, commandsLimit),
        renderMoreBtns()))) : null);
};
CardCommand.displayName = 'CardCommand';
export default observer(CardCommand);
